import type { AppRouteGroup } from 'app/store/components/NavigationUtils';

import DashboardConfig from './dashboard/DashboardConfig';
import ErrorsConfig from './errors/ErrorsConfig';
import ExchangeMailsLogsConfig from './exchange-mails-logs/ExchangeMailsLogsConfig';
import LoginConfig from './login/LoginConfig';
import LogsConfig from './logs/LogsConfig';
import PermissionsManagementConfig from './permissions-management/PermissionsManagementConfig';
import RecycleBinConfig from './recycle-bin/RecycleBinConfig';
import SettingsConfig from './settings/SettingsConfig';
import SystemTablesConfig from './system-table/SystemTablesConfig';
import VersionUpdateConfig from './version-update/VersionUpdateConfig';

const pagesConfigs: AppRouteGroup[] = [
	LoginConfig,
	DashboardConfig,
	ErrorsConfig,
	ExchangeMailsLogsConfig,
	LogsConfig,
	PermissionsManagementConfig,
	RecycleBinConfig,
	SettingsConfig,
	SystemTablesConfig,
	VersionUpdateConfig
];

export default pagesConfigs;
